/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboPouchManagementBadRequestResponse,
  BboPouchManagementFailureResponseResponse,
  BboPouchManagementForbiddenResponse,
  GetAccCardDataParams,
  GetAccCardResponseResponse,
  NoContentResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * Get AccCard-data.
 * @summary This endpoint is used to validate acc-card-barcode
 */
export const getAccCardData = (params: GetAccCardDataParams, signal?: AbortSignal) => {
  return customInstance<GetAccCardResponseResponse | NoContentResponse>({
    url: `/bm-pouch-management/v1/acc-card/validate`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetAccCardDataQueryKey = (params: GetAccCardDataParams) => {
  return [`/bm-pouch-management/v1/acc-card/validate`, ...(params ? [params] : [])] as const;
};

export const getGetAccCardDataQueryOptions = <
  TData = Awaited<ReturnType<typeof getAccCardData>>,
  TError = ErrorType<
    | BboPouchManagementBadRequestResponse
    | UnauthorizedResponse
    | BboPouchManagementForbiddenResponse
    | BboPouchManagementFailureResponseResponse
  >,
>(
  params: GetAccCardDataParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccCardData>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAccCardDataQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccCardData>>> = ({ signal }) =>
    getAccCardData(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAccCardData>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAccCardDataQueryResult = NonNullable<Awaited<ReturnType<typeof getAccCardData>>>;
export type GetAccCardDataQueryError = ErrorType<
  | BboPouchManagementBadRequestResponse
  | UnauthorizedResponse
  | BboPouchManagementForbiddenResponse
  | BboPouchManagementFailureResponseResponse
>;

/**
 * @summary This endpoint is used to validate acc-card-barcode
 */
export const useGetAccCardData = <
  TData = Awaited<ReturnType<typeof getAccCardData>>,
  TError = ErrorType<
    | BboPouchManagementBadRequestResponse
    | UnauthorizedResponse
    | BboPouchManagementForbiddenResponse
    | BboPouchManagementFailureResponseResponse
  >,
>(
  params: GetAccCardDataParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccCardData>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAccCardDataQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
